module.exports = __webpack_public_path__ + "img/lock.77da93f3.svg";